export const SET_ALERT = 'SET_ALERT';
export const UNSET_ALERT = 'UNSET_ALERT';

export const SET_ALERT_KEY = 'SET_ALERT_KEY';



// WEBPACK FOOTER //
// ./src/vuex/modules/alerts/types/mutations.js